<header>
  <h3>UCN MATRICULA EN LÍNEA</h3>
  <app-steps></app-steps>
</header>
<section class="wait-step  animate__animated" [ngClass]="{
  animate__fadeIn: configService.currentStep === 5
}" *ngIf="configService.currentStep === 5">
  <h3>Espere un momento...<br>enviando solicitud</h3>
  <h3>{{stateDocument}}</h3>
</section>
<section class="final-step animate__animated" [ngClass]="{
  animate__slideInDown: configService.currentStep === 6
}" *ngIf="configService.currentStep === 6">

  <h3 class="title">Universidad Central de Nicaragua<br />Gracias por preferirnos. El siguiente paso es:</h3>
  <p class="info">Realizar el pago de la matrícula, dispone de los siguientes métodos de pago</p>
  <!-- <iframe src="https://lottie.host/embed/fe3a2fcf-113e-4b8f-8113-94f85d720146/VJ3p2uzLmJ.json"></iframe> -->
  <div class="option-pay">
    <div>
      <img src="https://ucnvirtual.edu.ni/pixmatricula/resources/windowsUCN@2x.png" alt="">
      <h3>Realice el <a href="https://www.ucn.edu.ni/pagos-en-linea/" target="_blank">pago en línea</a></h3>

    </div>
    <div>
      <img src="https://ucnvirtual.edu.ni/pixmatricula/resources/bank@2x.png" alt="">
      <h3><a href="https://ucnvirtual.edu.ni/pixmatricula/resources/Información-Método-de-Pago-Banco.pdf"
          target="_blank">Bancos</a></h3>

    </div>

    <div>
      <img src="https://ucnvirtual.edu.ni/pixmatricula/resources/pay@2x.png" alt="">
      <h3>Pagar en caja</h3>
    </div>
  </div>
  <div class="option-pay-details" style="display: none;">
    <div id="pay-detail1">
      <p><b>PAGOS EN LÍNEA</b><br>
      <p>1. Escoge el campus.<br>
        2. En “Concepto de” seleccione la matricula de su carrera.<br>
        3. En “Detalle de concepto” escriba el numero tu código <b>{{randomNumer}}</b><br>
        4. Llene el resto del formulario.</p>
    </div>
    <div id="pay-detail2">
      <p><b>BANPRO</b><br>
        Cuenta en Córdobas:<br>
        • Nombre de la cuenta: UCN-Instituto Tecnológico Central
        Número de cuenta: <b>100-1040-5830064</b> <br>
        Cuenta en Dólares<br>
        • Nombre de la cuenta: Universidad Central de Nicaragua
        Número de cuenta: <b>100-104155-6933-0</b> <br>
        <b>BAC</b><br>
        Cuenta en Córdobas:<br>
        • Nombre de la cuenta: Universidad Central de Nicaragua
        Número de cuenta: <b> 010-019743</b><br>
        Cuenta en Dólares<br>
        • Nombre de la cuenta: Universidad Central de Nicaragua
        Número de cuenta: <b>000296285</b>
      </p>
    </div>
    <div id="pay-detail3">
      <p><b>CAJA</b><br>
      <p>En un periodo de 24 horas será contactado por un especialista de nuestro Centro de Atención<br>
        Estudiantil CAE para indicarle el procedimiento de pago en Caja UCN y asesorarlo en nuestros <br> académicos,
        brindarle su número de carné (CIF) y responder cualquier consulta que usted tenga. </p>
    </div>


  </div>
  <p class="info" style="font-weight: 700;">Para cualquier método de pago que elija, en detalle de concepto escriba el <u>primer nombre y primer apellido</u> del matriculando.
  </p>
  <!-- <h3 class="title number">{{randomNumer}}</h3> -->
  <p class="info">
    Para mayor información del proceso contactar al:<br>
    Celular: +505 8252 3159 (WhatsApp)<br>
    Correo electrónico: admisionestudiantildrpi@ucn.edu.ni

  </p>
  <button style="align-self: center; margin-top: 16px;" class="btn" type="button" (click)="reloadPage()">
    Ir al inicio
  </button>

</section>


<!-- <div class="main">
  <div class="bg"></div>
  <div
    class="animate__animated text firstLetter"
    *ngIf="configService.currentStep === 2"
    [ngClass]="{
      animate__fadeIn: configService.currentStep === 2,
      animate__fadeOut: configService.currentStep != 2
    }"
    [ngStyle]="{ 'background-position': transX + '%' + transY + '%' }"
  >
    {{ configService.currentLetter }}
  </div>
  <div
    class="animate__animated text secondLetter"
    *ngIf="configService.currentStep === 3"
    [ngClass]="{
      animate__fadeIn: configService.currentStep === 3,
      animate__fadeOut: configService.currentStep != 3
    }"
    [ngStyle]="{ 'background-position': transX + '%' + transY + '%' }"
  >
    {{ configService.currentLetter }}
  </div>
  <div
    class="animate__animated text thirdLetter"
    *ngIf="configService.currentStep === 4"
    [ngClass]="{
      animate__fadeIn: configService.currentStep === 4,
      animate__fadeOut: configService.currentStep != 4
    }"
    [ngStyle]="{ 'background-position': transX + '%' + transY + '%' }"
  >
    {{ configService.currentLetter }}
  </div>
</div> -->

<main #allForm class="all-form">
  <div class="animate__animated message" *ngIf="!isCloseMessage" >
    <i class="fa fa-info-circle" aria-hidden="true"></i>
    <p>UCN se reserva el derecho de verificación de los documentos de admisión adjuntos, una vez completado el proceso de matrícula en línea debe presentarse a la sede de UCN para la toma de fotografía de carné, muestra en físico de los documentos de admisión y entrega de matrícula en físico.</p>
    <i id="btnCloseMessage" class="fa fa-times-circle" aria-hidden="true" (click)="closeMessage()"></i>
  </div>
  <form action="" [formGroup]="welcomeValidation" class="animate__animated" *ngIf="configService.currentStep === 1"
    [ngClass]="{
      animate__fadeOut: configService.currentStep != 1,
      animate__fadeIn: configService.currentStep === 1
    }">
    <section class="form-step-welcome">
      <h3 class="title-step">Bienvenido</h3>
      <h3 class="subTitle-step">Seleccione el campus donde quiere estudiar</h3>
      <div class="content-campus">
        <input class="radio-campus" id="radio-ccentral" type="radio" name="campus" formControlName="campus"
          value="central" (change)="radioCampusChange($event)" />
        <label class="label-campus" for="radio-ccentral">
          <div class="cover">
            <img src="https://ucnvirtual.edu.ni/pixmatricula/resources/ccentral2.jpg" alt="" />
          </div>
          <h4 class="title-campus">Campus Central</h4>
        </label>
        <!-- campus doral -->
        <input class="radio-campus" id="radio-cdoral" type="radio" name="campus" formControlName="campus" value="doral"
          (change)="radioCampusChange($event)" />
        <label class="label-campus" for="radio-cdoral">
          <div class="cover">
            <img src="https://ucnvirtual.edu.ni/pixmatricula/resources/cdoral.jpg" alt="" />
          </div>
          <h4 class="title-campus">Campus Doral</h4>
        </label>
        <!-- campus jinotepe -->
        <input class="radio-campus" id="radio-cjinotepe" type="radio" name="campus" formControlName="campus"
          value="jinotepe" (change)="radioCampusChange($event)" />
        <label class="label-campus" for="radio-cjinotepe">
          <div class="cover">
            <img src="https://ucnvirtual.edu.ni/pixmatricula/resources/cjinotepe.jpg" alt="" />
          </div>
          <h4 class="title-campus">Campus Jinotepe</h4>
        </label>
        <!-- campus esteli -->
        <input class="radio-campus" id="radio-cesteli" type="radio" name="campus" formControlName="campus"
          value="esteli" (change)="radioCampusChange($event)" />
        <label class="label-campus" for="radio-cesteli">
          <div class="cover">
            <img src="https://ucnvirtual.edu.ni/pixmatricula/resources/cesteli.jpg" alt="" />
          </div>
          <h4 class="title-campus">Campus Esteli</h4>
        </label>
      </div>
      <h3 class="subTitle-step">Seleccione la carrera que va a cursar</h3>
      <label class="group-text" for="">
        <div class="selectdiv">
          <label>
            <select id="select-career" formControlName="career" name="career"
              (ngModelChange)="getSelectedCareer($event)">
              <option disabled="disabled">Lista de Carreras</option>
              <option value="" selected disabled hidden>Seleccione</option>
              <option *ngFor="let careerName of campusSelectedList" [ngValue]="careerName">
                {{ careerName.name }}
              </option>
            </select>
          </label>
        </div>
      </label>

      <h3 class="subTitle-step">Escoja el turno</h3>
      <label class="group-text" for="">
        <div class="selectdiv">
          <label>
            <select id="select-turn" formControlName="turn" name="turn">
              <option disabled="disabled">Turnos disponibles</option>
              <option value="" selected disabled hidden>Seleccione</option>
              <option value="Regular" *ngIf="isRegular">Regular</option>
              <option value="Sabatino" *ngIf="isSabbatine">Sabatino</option>
              <option value="Dominical" *ngIf="isDominical">Dominical</option>
            </select>
          </label>
        </div>
      </label>

      <div class="step-one button">
        <button [disabled]="welcomeValidation.invalid" class="btn" type="button" (click)="goToStep1()">
          Empezar&nbsp;&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </section>
  </form>
  <form id="form-step1" class="animate__animated" [formGroup]="stepValidation1" *ngIf="configService.currentStep === 2"
    [ngClass]="{
      animate__fadeOutRight: configService.currentStep != 2,
      animate__fadeInRight: configService.currentStep === 2
    }">
    <img  class="img-form animate__animated" src="assets/resources/uLetter_m.webp" alt="">
    <section class="form-step-one">
      <h3 id="title-step1" class="title-step">Datos Personales del Estudiante</h3>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Nombre</h3>
          <input formControlName="name" type="text" #name />
          <!-- <div
            *ngIf="
              stepValidation1.controls['name'].invalid &&
              (stepValidation1.controls['name'].dirty ||
                stepValidation1.controls['name'].touched)
            "
          >
            cosas de la vida
            <div *ngIf="stepValidation1.controls['name'].errors.required">
              Name is required.
            </div>
          </div> -->
        </label>
        <label class="group-text" for="">
          <h3>Apellido</h3>
          <input type="text" formControlName="lastname" />
        </label>
        <!-- <button [disabled]="matriculaForm.invalid" class="btn" type="submit"> Guardar </button> -->
      </div>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Fecha de Nacimiento</h3>
          <input type="date" formControlName="birthday" name="birthday" (change)="getSelectedBirth($event)"
            placeholder="dd/mm/aaaa" min="1970-01-01" max="2012-12-31" />
          <div *ngIf="primaryBirthday.touched || primaryBirthday.dirty">
            <small *ngIf="Age<16 && careerSelected.name=='Derecho'" class="text-danger">Eres menor de edad para la
              carrera de Derecho</small>


          </div>
        </label>
      </div>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Género</h3>

          <div class="g-two">
            <label for="opt1" class="radio">
              <input formControlName="gender" type="radio" id="opt1" class="hidden" value="masculino"
                (change)="radioGenChangeHandler($event)" />
              <span class="label"></span>Masculino<br />
            </label>
            <label for="opt2" class="radio">
              <input formControlName="gender" type="radio" id="opt2" class="hidden" value="femenino"
                (change)="radioGenChangeHandler($event)" />
              <span class="label"></span>Femenino<br />
            </label>
          </div>
        </label>
      </div>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Estado Civil</h3>
          <div class="selectdiv">
            <label>
              <select id="select-civil-status" formControlName="civil_status" name="civil_status">
                <option disabled="disabled">Estado Civil</option>
                <option value="" selected disabled hidden>Seleccione</option>
                <option *ngFor="let civilS of civilStatuslist" [ngValue]="civilS.name">
                  {{ civilS.name }}
                </option>
              </select>
            </label>
          </div>
        </label>
      </div>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Nacionalidad</h3>
          <div class="selectdiv">
            <label>
              <select id="select-nationality" formControlName="nationality" name="nationality">
                <option disabled="disabled">Países</option>
                <option value="" selected disabled hidden>Seleccione</option>
                <option *ngFor="let country of countryList" [ngValue]="country.name">
                  {{ country.name }}
                </option>
              </select>
            </label>
          </div>
        </label>
      </div>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Documento de identidad</h3>
          <div class="selectdiv">
            <label>
              <select id="select-identity" (change)="getSelectedIdentity($event)" formControlName="doc">
                <option disabled="disabled">Tipos de documentos</option>
                <option value="" selected disabled hidden>Seleccione</option>
                <option *ngFor="let docList of list" [ngValue]="docList.name">
                  {{ docList.name }}
                </option>
              </select>
            </label>
          </div>
        </label>
        <label class="group-text" for="">
          <h3>{{ docType }}</h3>

          <input [ngClass]="{
              error:
                stepValidation1.controls['docValue'].invalid &&
                (stepValidation1.controls['docValue'].dirty ||
                  stepValidation1.controls['docValue'].touched)
            }" type="text" formControlName="docValue" name="docValue" />
        </label>
      </div>
      <div class="step-one button">
        <button [disabled]="" class="btn back" type="button" (click)="backToWelcome()">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;&nbsp;Atras
        </button>
        <button [disabled]="stepValidation1.invalid" class="btn" type="button" (click)="goToStep2()">
          Siguiente&nbsp;&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </section>
  </form>
  <form id="form-step2" class="animate__animated" [formGroup]="stepValidation2" *ngIf="configService.currentStep === 3"
    [ngClass]="{
      animate__fadeOutRight: configService.currentStep != 3,
      animate__fadeInRight: configService.currentStep === 3
    }">
     <img class="img-form animate__animated" src="assets/resources/cLetter_m.webp" alt="">
    <section class="form-step-one">
      <h3 class="title-step">Datos de Contacto del Estudiante</h3>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Correo Electrónico</h3>
          <input formControlName="email" type="text" placeholder="ej. fulanoxyz@gmail.com" name="email" />
          <div *ngIf="(primaryEmail.invalid && primaryEmail.touched) || primaryEmail.dirty">
            <small *ngIf="primaryEmail.errors?.required" class="text-danger">El correo electrónico es requerido</small>

            <small *ngIf="primaryEmail.errors?.pattern" class="text-danger">Por favor ingrese un correo electrónico
              válido</small>
          </div>
        </label>


      </div>

      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Teléfono de Casa</h3>
          <input type="tel" placeholder="ej. +505 1800 2020" formControlName="telHome" name="telhome" />
        </label>
      </div>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Teléfono Celular</h3>
          <input type="tel" formControlName="cellular" name="cellular" />
        </label>
        <label class="group-text" style="
            display: flex;
            flex-direction: row-reverse;
            align-self: center;
            margin-top: 12px;
          " for="">
          <h3 style="margin-left: 8px">WhatsApp</h3>
          <input type="checkbox" formControlName="wa" name="wa" />
        </label>
      </div>

      <div class="step-one name">
        <label class="group-text" for="">
          <h3>País de Residencia</h3>
          <div class="selectdiv">
            <label>
              <select id="select-country" formControlName="countryForm1" name="countryForm1"
                (change)="getSelectedCountry($event)">
                <option disabled="disabled">Países</option>
                <option value="" disabled hidden selected>Seleccione</option>
                <option *ngFor="let country of countryList" [ngValue]="country.name">
                  {{ country.name }}
                </option>
              </select>
            </label>
          </div>
        </label>
        <label class="group-text" for="">
          <h3>Departamento/Estado/Provincia</h3>
          <div class="selectdiv">
            <label>
              <select id="select-state" formControlName="stateForm1" name="stateForm1">
                <option disabled="disabled">Estado/Departamento</option>
                <option value="" disabled hidden selected>Seleccione</option>
                <option *ngFor="let state of stateList1" [ngValue]="state">
                  {{ state}}
                </option>
              </select>
            </label>
          </div>
        </label>
      </div>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Ciudad</h3>
          <input type="text" placeholder="ej. Managua" formControlName="cityForm1" name="cityForm1" />
        </label>
        <label class="group-text" for="">
          <h3>Dirección Domiciliar</h3>

          <textarea formControlName="addressForm1" name="addressForm1" rows="4
        " cols="38"></textarea>
        </label>
      </div>
      <div class="step-one button">
        <button [disabled]="" class="btn back" type="button" (click)="backToStep1()">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;&nbsp;Atras
        </button>
        <button [disabled]="stepValidation2.invalid" class="btn" type="button" (click)="goToStep3()">
          Siguiente&nbsp;&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </section>
  </form>
  <form class="animate__animated" id="form-step3" [formGroup]="stepValidation3" *ngIf="configService.currentStep == 4"
    [ngClass]="{
      animate__fadeOutRight: configService.currentStep != 4,
      animate__fadeInRight: configService.currentStep === 4
    }">
     <img  class="img-form animate__animated" src="assets/resources/nLetter_m.webp"  alt="">
    <section class="form-step-one">
      <h3 class="title-step">Información Académica y Laboral</h3>

      <h3 class="subTitle-step">Centro de estudio</h3>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Nombre del Centro de Estudio</h3>
          <input type="text" formControlName="school_name" />
        </label>
        <label class="group-text" for="">
          <h3>Tipo de Centro de Estudio</h3>
          <div class="selectdiv">
            <label>
              <select id="select-school" formControlName="school_type">
                <option disabled="disabled">
                  Tipo de Centro de Estudio
                </option>
                <option value="" selected disabled hidden>Seleccione</option>
                <option *ngFor="let schoolList of school" [ngValue]="schoolList.name">
                  {{ schoolList.name }}
                </option>
              </select>
            </label>
          </div>
        </label>
      </div>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>País de Ubicación</h3>
          <div class="selectdiv">
            <label>
              <select id="select-country" formControlName="school_country" (change)="getSelectedSchoolCountry($event)">
                <option disabled="disabled">Países</option>
                <option value="" selected disabled hidden>Seleccione</option>
                <option *ngFor="let country of countryList" [ngValue]="country.name">
                  {{ country.name }}
                </option>
              </select>
            </label>
          </div>
        </label>
        <label class="group-text" for="">
          <h3>Departamento/Estado/Provincia</h3>
          <div class="selectdiv">
            <label>
              <select id="select-state" formControlName="school_state">
                <option disabled="disabled">Estados/Depart...</option>
                <option value="" selected disabled hidden>Seleccione</option>
                <option *ngFor="let state of stateList2" [ngValue]="state">
                  {{ state }}
                </option>
              </select>
            </label>
          </div>
        </label>
      </div>

      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Ciudad</h3>
          <input type="text" placeholder="ej. Managua" formControlName="school_city" />
        </label>
        <label class="group-text" for="">
          <h3>Dirección del centro de estudio</h3>

          <textarea formControlName="school_address" rows="4
        " cols="38"></textarea>
        </label>
      </div>
      <h3 class="subTitle-step">Subida de documentos</h3>
      <div class="step-one name">
        <div class="content-file">
          <p class="title-file">Diploma o Título (Opcional solo si está en trámite):</p>
          <div class="upload-details">
            <input formControlName="file1" type="file" name="" id="file1" style="display: none;"
              (change)="openDiploma($event)" />
            <label class="upload-file" for="file1"><i class="fa fa-upload" aria-hidden="true"></i>Subir Archivo</label>
            <span>{{urlDiplomaName}}</span>
          </div>
          <p class="title-file">Certificado de IV y V año:</p>

          <div class="upload-details">
            <input type="file" formControlName="file2" multiple="multiple" name="" id="file2" style="display: none;"
              (change)="openCertificate($event)" />
            <label class="upload-file" for="file2"><i class="fa fa-upload" aria-hidden="true"></i>Subir Archivo</label>
            <span>{{urlCertificateName}}</span>
          </div>

          <p class="title-file">Cédula cara 1: </p>

          <div class="upload-details">
            <input formControlName="file3" type="file" name="" id="file3" style="display: none;"
              (change)="openIndetiCard1($event)" />
            <label class="upload-file" for="file3"><i class="fa fa-id-card-o" aria-hidden="true"></i>Subir
              Archivo</label>
            <span>{{urlIdentiCard1Name}}</span>
          </div>
          <p class="title-file">Cédula cara 2: </p>
          <div class="upload-details">
            <input formControlName="file4" type="file" name="" id="file4" style="display: none;"
              (change)="openIndetiCard2($event)" />
            <label class="upload-file" for="file4"><i class="fa fa-id-card-o" aria-hidden="true"></i>Subir
              Archivo</label>
            <span>{{urlIdentiCard2Name}}</span>
          </div>
          <p class="title-file">Certificado de nacimiento: </p>
          <div class="upload-details">
            <input formControlName="file5" type="file" name="" id="file5" style="display: none;"
              (change)="openPhoto($event)" />
            <label class="upload-file" for="file5"><i class="fa fa-upload" aria-hidden="true"></i>Subir Archivo</label>
            <span>{{urlPhotoName}}</span>
          </div>

        </div>
      </div>
      <h3 class="subTitle-step">Datos laborales (Opcional)</h3>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Centro de trabajo</h3>
          <input formControlName="workplace" type="text" />
        </label>
        <label class="group-text" for="">
          <h3>Ocupación</h3>
          <input type="text" placeholder="ej. Gerente de ventas" formControlName="occupation" />
        </label>

        <!-- <button [disabled]="matriculaForm.invalid" class="btn" type="submit"> Guardar </button> -->
      </div>
      <h3 class="subTitle-step">Rango de ingresos familiares</h3>
      <div class="step-one name">
        <label class="group-text" for="">
          <h3>Rango</h3>
          <div class="selectdiv">
            <label>
              <select id="select-rango" (change)="getSelectedIdentity($event.target.value)" formControlName="rank">
                <option disabled="disabled">
                  Seleccione el rango de ingresos
                </option>
                <option value="" selected disabled hidden>Seleccione</option>
                <option *ngFor="let rangoList of rango">
                  {{ rangoList.name }}
                </option>
              </select>
            </label>
          </div>
        </label>
      </div>
      <div class="step-one button">
        <button [disabled]="" class="btn back" type="button" (click)="backToStep2()">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;&nbsp;Atras
        </button>
        <button (click)="endStep()" [disabled]="stepValidation3.invalid" class="btn" type="button">
          Terminar&nbsp;&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </section>
  </form>
</main>